import styles from './full-view-dialog.module.scss';

export const DialogBackdrop = () => (
    <div className={styles.backdrop} data-model="full-view-dialog-backdrop" />
);
